export const paymentMap = {
  application: {
    title: '플랜 신청',
    path: '/payment/plan/application',
    display: true,
  },
  settlement: {
    title: '플랜 요금 정산',
    path: '/payment/plan/settlement',
    display: true,
  },
  retry: {
    title: '결제 재시도',
    path: '/payment/retry',
    display: true,
  },
};
